// MUST MATCH THE FOLDER /assets/images

export enum Image {
    STARS = 'stars',
    FIRST = 'first',
    SECOND = 'second',
    THIRD = 'third',
    NEW_FIRST = 'new_first',
    NEW_SECOND = 'new_second',
    NEW_THIRD = 'new_third',
}
